<template>
  <div>
    <div
      v-if="loadingPage"
      class="d-flex justify-content-center align-items-center"
      style="min-height: 300px"
    >
      <BSpinner
        variant="primary"
        label="Memuat data order..."
      />
    </div>
    <BCard
      v-else-if="showMessage"
      class="mt-2"
    >
      <div class="d-flex flex-column align-items-center py-5">
        <img
          src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/danger.svg"
          width="48"
          class="mb-3"
        >
        <p class="text-danger font-weight-bold mb-1">
          Order tidak ditemukan
        </p>
        <p class="text-muted text-sm">
          {{ messageNotFound }}
        </p>
        <BButton
          variant="primary"
          class="mt-2"
          @click="$router.push({ name: 'search-order' })"
        >
          Kembali
        </BButton>
      </div>
    </BCard>

    <div
      v-else-if="showDataOrder"
      class="d-flex align-items-center mb-3"
    >
      <BButton
        variant="none"
        class="p-0 mr-2 d-flex align-items-center justify-content-center"
        style="background-color: #F95031; border-color: #F95031; width: 32px; height: 32px; border-radius: 8px; color: white;"
        @click="$router.push({ name: 'search-order' })"
      >
        <b-icon-chevron-left font-scale="1.1" />
      </BButton>
      <h4 class="text-black font-weight-bold mb-0">
        Detail Order
      </h4>
    </div>

    <BCard
      v-if="showDataOrder && data.partner_information"
      class="mt-2"
    >
      <BRow class="mb-1">
        <BCol
          cols="3"
          class="font-weight-bold text-dark"
          style="min-width:150px"
        >
          Nama Partner
        </BCol>
        <BCol cols="9">
          : {{ data.partner_information.partner_name || '-' }}
        </BCol>
      </BRow>
      <BRow class="mb-1">
        <BCol
          cols="3"
          class="font-weight-bold text-dark"
          style="min-width:150px"
        >
          Email
        </BCol>
        <BCol cols="9">
          : {{ data.partner_information.partner_email || '-' }}
        </BCol>
      </BRow>
      <BRow class="mb-0">
        <BCol
          cols="3"
          class="font-weight-bold text-dark"
          style="min-width:150px"
        >
          No Handphone
        </BCol>
        <BCol cols="9">
          : {{ data.partner_information.partner_phone_number || '-' }}
        </BCol>
      </BRow>
    </BCard>
    <BCard
      v-if="showDataOrder"
      class="mt-2"
    >

      <div class="flex justify-between items-center">
        <div class="text-black text-xl font-medium">
          Detail Order
        </div>

        <div class="flex gap-[1rem] h-[38px]">
          <b-dropdown
            variant="primary"
            split
            :text="invoiceFormatLabel"
            @click="handleDownloadInvoice"
          >
            <b-dropdown-item
              :active="invoiceFormat === 'pdf'"
              @click="invoiceFormat = 'pdf'"
            >
              Invoice PDF
            </b-dropdown-item>
            <b-dropdown-item
              :active="invoiceFormat === 'image'"
              @click="invoiceFormat = 'image'"
            >
              Invoice Image
            </b-dropdown-item>
            <b-dropdown-form>
              <b-form-checkbox v-model="showPriceInvoice">
                Harga Produk
              </b-form-checkbox>
            </b-dropdown-form>
          </b-dropdown>
          <BButton
            variant="primary"
            :disabled="isDisableUpdateOrder"
            @click="$bvModal.show('confirm-update-order')"
          >
            Check Update
          </BButton>
          <BButton
            v-if="data.is_komship === 0"
            variant="outline-primary"
            @click="handleCancelOrder"
          >
            Cancel Order
          </BButton>

          <BDropdown
            variant="outline-primary"
            no-caret
            right
            lazy
            size="sm"
            class="order-dropdown"
          >
            <template #button-content>
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/more.svg"
                alt="more"
              >
            </template>
            <BDropdownItemButton
              class="order-dropdown-item"
              @click="handleCancelOrder"
            >
              Cancel Order
            </BDropdownItemButton>
            <BDropdownItemButton
              class="order-dropdown-item"
              :disabled="isDisableButtonPaketHilangAndPaketRusak"
              @click="handlePaketHilang"
            >
              Paket Hilang
            </BDropdownItemButton>
            <BDropdownItemButton
              class="order-dropdown-item"
              :disabled="isDisableButtonPaketHilangAndPaketRusak || data.is_retur === 2"
              @click="handlePaketRusak"
            >
              Paket Rusak
            </BDropdownItemButton>
            <BDropdownItemButton
              v-if="['Dikirim'].some(status => status === data.order_status)"
              class="order-dropdown-item"
              @click="handleDeliveredPackage"
            >
              Paket Diterima
            </BDropdownItemButton>
            <li
              v-if="data.order_status === 'Dikirim' || isOrderReturDalamPerjalanan"
              class="dropdown-submenu"
            >
              <BDropdownItemButton
                class="order-dropdown-item"
              >
                <div class="d-flex justify-content-between align-items-center">
                  <span>Paket Retur</span>
                  <b-icon-chevron-right class="ml-auto" />
                </div>
              </BDropdownItemButton>
              <div class="submenu-list">
                <BDropdownItemButton
                  class="order-dropdown-item"
                  @click="handleReturMemotong"
                >
                  Memotong Saldo
                </BDropdownItemButton>
                <BDropdownItemButton
                  class="order-dropdown-item"
                  @click="handleReturTidakMemotong"
                >
                  Tidak Memotong Saldo
                </BDropdownItemButton>
              </div>
            </li>
          </BDropdown>
        </div>
      </div>
      <BRow class="mt-2 justify-center">
        <BCol lg="11">
          <div class="text-black text-lg">
            Informasi Order
          </div>
          <BCard body-class="bg-[#ffffff] border border-[1px] rounded-lg mt-2">
            <BRow class="mb-1">
              <BCol cols="4">
                No Order
              </BCol>
              <BCol
                cols="8"
                class="font-bold text-black"
              >
                {{ data.order_no }}
              </BCol>
            </BRow>
            <BRow class="mb-1">
              <BCol cols="4">
                Tanggal Order
              </BCol>
              <BCol
                cols="8"
                class="font-bold text-black"
              >
                {{ DAY_MONTH_YEAR(data.order_date) }}
              </BCol>
            </BRow>
            <BRow class="mb-1">
              <BCol cols="4">
                Metode Pembayaran
              </BCol>
              <BCol
                cols="8"
                class="font-bold text-black"
              >
                {{ data.payment_method }}
              </BCol>
            </BRow>
            <BRow class="mb-1">
              <BCol
                cols="4"
                class="flex items-center"
              >
                Status
              </BCol>
              <BCol
                cols="8"
                class="font-bold"
              >
                <b-alert
                  show
                  :variant="statusOrderVariant"
                  class="max-w-60 d-flex justify-content-center"
                >
                  <BadgeStatusOrder
                    :status-order="data.order_status"
                    :retur="data.is_retur"
                  />
                </b-alert>
              </BCol>
            </BRow>
            <BRow
              class="mb-1"
            >
              <BCol cols="4">
                No Tiket
              </BCol>
              <BCol
                cols="8"
                class="font-bold text-black"
                :class="data.is_problem === 1 ? 'cursor-pointer hover:underline hover:text-[#F95031]' : ''"
                @click="data.is_problem === 1 ? navigateToTicketDetail() : null"
              >
                {{ noTicket }}
              </BCol>
            </BRow>
            <span class="d-flex mt-10 mb-1">Telah ditambahkan oleh ‘{{ data.user_fullname }}’ pada {{ FULL_DATE_TIME(data.order_date) }} WIB.</span>
            <span
              v-if="data.user_name_edited !== null || data.order_edited_date !== null"
              class="d-flex mb-6"
            >Telah diedit oleh ‘{{ data.user_name_edited }}’ pada {{ FULL_DATE_TIME(data.order_edited_date) }} WIB.</span>
          </BCard>
        </BCol>
      </BRow>
      <BRow class="mt-2 justify-center">
        <BCol lg="11">
          <div class="text-black text-lg">
            Informasi Pengiriman
          </div>
          <BCard body-class="bg-[#ffffff] border border-[1px] rounded-lg mt-2">
            <BRow class="mb-1">
              <BCol cols="6">
                <div class="d-flex">
                  <BAvatar />
                  <div class="ml-1 my-auto">
                    <span class="font-bold text-black">{{ data.customer_name }}</span><br>
                    <span>(+62){{ parseInt(data.customer_phone, 10) }}</span>
                  </div>
                </div>
              </BCol>
              <BCol cols="6">
                <div
                  class="d-flex my-auto justify-end"
                >
                  <div class="align-content-center text-black">
                    Pengiriman via
                  </div>
                  <img
                    :src="data.is_komship === 1 ? 'https://storage.googleapis.com/komerce//komshiplogo.svg' : 'https://storage.googleapis.com/komerce/rajaongkir/RajaOngkir.svg'"
                    class="w-32"
                    style="margin-left:5px;"
                    :alt="data.is_komship === 1 ? 'Komship' : 'RajaOngkir'"
                  >
                </div>
              </BCol>
            </BRow>
            <b-row
              v-if="data.shipping === 'SPX' && ['Diajukan', 'Dipacking', 'Dikirim', 'Retur'].includes(data.order_status)"
              class="mb-1"
            >
              <b-col
                cols="12"
              >
                <div
                  :class="data.promotions.includes('free_retur') ? 'bg-[#DCF3EB]' : 'bg-[#FFEDED]'"
                  class="rounded rounded-lg p-1 d-flex gap-2"
                >
                  <div>
                    <span
                      :class="data.promotions.includes('free_retur') ? 'k-Checklist rounded-pill text-[#10673E]' : 'k-close-circle text-[#79170A]'"
                      class="text-xl"
                      :style="data.promotions.includes('free_retur') ? 'border: 1px solid #10673E' : ''"
                    />
                  </div>
                  <div>
                    <div
                      class="font-semibold text-lg text-black"
                    >
                      {{ data.promotions.includes('free_retur') ? `Gratis Ongkos ${ data.payment_method === 'COD' ? 'Kirim &' : '' } Pengembalian` : `Tidak Ada Gratis Ongkos ${ data.payment_method === 'COD' ? 'Kirim' : 'Pengembalian' }` }}
                    </div>
                    <div class="d-flex gap-1 text-black">
                      <span>{{ data.promotions.includes('free_retur') ? `Selamat! Rasio returmu rendah, orderan kamu mendapatkan gratis ongkos ${ data.payment_method === 'COD' ? 'kirim dan' : '' } pengembalian saat order berakhir Retur (RTS)` : `Turunkan Rasio Returmu, untuk mendapatkan gratis ongkos ${ data.payment_method === 'COD' ? 'kirim' : 'pengembalian' } saat order berakhir Retur (RTS).` }}</span>
                      <a
                        class="text-[#08A0F7] underline"
                        href="https://bantuan.komerce.id/id/article/program-gratis-ongkir-bolak-balik-spx-di-komship-erdcme/?bust=1758189095543"
                        target="_blank"
                      >Selengkapnya</a>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <BRow class="mb-1">
              <BCol cols="4">
                Ekspedisi
              </BCol>
              <BCol
                cols="8"
                class="font-bold d-flex"
              >
                <img
                  :src="data.shipment_image_path"
                  style="width: 45px"
                >
                <span
                  class="my-auto"
                  style="margin-left:5px"
                >
                  {{ data.shipment_alias }}
                </span>
              </BCol>
            </BRow>
            <BRow class="mb-1">
              <BCol cols="4">
                No Resi
              </BCol>
              <BCol
                cols="8"
                class="font-bold d-flex items-center"
              >
                {{ data.airway_bill }}
                <img
                  v-if="data.airway_bill"
                  src="https://storage.googleapis.com/komerce/assets/icons/copy.png"
                  class="copy-resi cursor-pointer ml-1"
                  @click.prevent="copyResi(data.airway_bill)"
                >
                <span v-if="data.airway_bill === null">-</span>
              </BCol>
            </BRow>
            <BRow class="mb-1">
              <BCol cols="4">
                Detail Alamat
              </BCol>
              <BCol
                cols="8"
                class="font-bold"
              >
                {{ data.customer_address }}
              </BCol>
            </BRow>
            <BRow class="mt-3">
              <BCol class="d-flex justify-content-end gap-2">
                <BButton
                  v-if="data.is_problem === 1"
                  variant="outline-primary"
                  @click="navigateToTicketDetail()"
                >
                  Lihat Tiket
                </BButton>
                <BButton
                  :disabled="data.airway_bill === null || data.airway_bill === ''"
                  :variant="data.airway_bill === null || data.airway_bill === '' ? 'secondary' : 'primary'"
                  @click="$bvModal.show('print-label')"
                >
                  Print Label
                </BButton>
                <BButton
                  v-if="trackingShowCondition(data.order_status)"
                  variant="outline-primary"
                  @click="getTicketTrip()"
                >
                  <BSpinner
                    v-if="loading"
                    small
                    variant="primary"
                  />
                  Lacak Resi
                </BButton>
              </BCol>
            </BRow>
          </BCard>
        </BCol>
      </BRow>
      <BRow class="justify-center">
        <BCol lg="11">
          <div class="text-black text-lg">
            Informasi Penjualan
          </div>
          <BCard body-class="pl-0 pr-0">
            <BTable
              responsive
              :fields="fields"
              :items="items"
            >
              <template #cell(no)="value">
                {{ value.index + 1 }}
              </template>
              <template #cell(product_name)="value">
                <div class="flex items-center">
                  <img
                    :src="value.item.product_image !== null ? value.item.product_image : 'https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg'"
                    alt="Komerce"
                    class="w-[45px]"
                  >
                  <div class=" ml-[5px]">
                    <div class="text-black">
                      {{ value.item.product_name }}
                    </div>
                    <div class="text-[#E31A1A]">
                      {{ value.item.variant_name }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(price)="value">
                {{ IDR(value.item.price) }}
              </template>
              <template #cell(subtotal)="value">
                {{ IDR(value.item.price * value.item.qty) }}
              </template>
            </BTable>
            <hr>
            <BRow
              v-if="data.order_notes !== null"
              class="mt-3 justify-center"
            >
              <BCol lg="12">
                <span class="text-black text-xl">Catatan Order</span>
                <BFormTextarea
                  v-model="data.order_notes"
                  disabled
                  no-resize
                  class="mt-1"
                />
              </BCol>
            </BRow>
            <BRow class="mt-3 justify-end">
              <BCol lg="3" />
              <BCol lg="5">
                Total Harga Produk
              </BCol>
              <BCol
                lg="3"
                class="text-right"
              >
                {{ IDR(data.subtotal) }}
              </BCol>
            </BRow>
            <BRow class="mt-1 justify-end">
              <BCol lg="3" />
              <BCol lg="5">
                Ongkos Kirim
              </BCol>
              <BCol
                lg="3"
                class="text-right"
              >
                + {{ IDR(data.shipping_cost) }}
              </BCol>
            </BRow>
            <BRow class="mt-1 justify-end">
              <BCol lg="3" />
              <BCol lg="5">
                Potongan Harga
              </BCol>
              <BCol
                lg="3"
                class="text-right"
              >
                {{ data.discount > 0 ? '-' : '' }} {{ IDR(data.discount) }}
              </BCol>
            </BRow>
            <BRow class="mt-1 justify-end">
              <BCol lg="3" />
              <BCol lg="5">
                Biaya Lain
              </BCol>
              <BCol
                lg="3"
                class="text-right"
              >
                {{ data.additional_cost > 0 ? '+' : '' }} {{ IDR(data.additional_cost) }}
              </BCol>
            </BRow>
            <BRow class="mt-1 justify-end">
              <BCol lg="3" />
              <BCol lg="8">
                <hr><span />
              </BCol>
            </BRow>
            <BRow
              class="mt-1 justify-end"
              :class="data.order_status === 'Retur' ? 'line-through' : ''"
            >
              <BCol lg="3" />
              <BCol
                lg="5"
                class="font-bold text-xl"
              >
                Total Pembayaran ({{ data.payment_method }}) :
              </BCol>
              <BCol
                lg="3"
                class="text-right font-bold text-primary text-xl"
              >
                {{ IDR(data.grandtotal) }}
              </BCol>
            </BRow>
            <BRow
              v-if="data.notes === '*Nilai pembayaran sudah disesuaikan dengan fitur input cepat'"
              class="mt-1 justify-end font-semibold text-sm text-primary"
            >
              <BCol lg="3" />
              <BCol lg="8">
                {{ data.notes }}
              </BCol>
            </BRow>
            <BRow class="mt-1 justify-end">
              <BCol lg="3" />
              <BCol lg="5">
                <hr><span />
              </BCol>
              <BCol
                lg="3"
                class="d-flex justify-end"
              >
                <BButton
                  v-b-toggle="'collapse-1'"
                  class="buttonCollapse px-0"
                  variant="none"
                  size="sm"
                >
                  <span class="when-open">Tutup <b-icon-chevron-up /></span>
                  <span class="when-closed">Buka <b-icon-chevron-down /></span>
                </BButton>
              </BCol>
            </BRow>
            <BCollapse id="collapse-1">
              <BRow class="mt-1 justify-end">
                <BCol lg="3" />
                <BCol
                  lg="5"
                >
                  {{ data.payment_method }} ({{ data.service_fee_to }}% sudah termasuk PPN)
                </BCol>
                <BCol
                  lg="3"
                  class="text-right"
                >
                  - {{ IDR(data.service_fee) }}
                </BCol>
              </BRow>
              <BRow class="mt-1 justify-end">
                <BCol lg="3" />
                <BCol
                  lg="5"
                >
                  Ongkos Kirim (dipotong Cashback {{ data.cashback_to }}%)
                </BCol>
                <BCol
                  lg="3"
                  class="text-right text-[#F95031]"
                >
                  {{ data.shipping === 'SPX' && data.promotions.includes('free_retur') && data.payment_method === 'COD' && data.order_status === 'Retur' ? `- ${IDR(0)}` : `- ${IDR(data.shipping_cost - data.shipping_cashback)}` }}
                </BCol>
              </BRow>
              <BRow
                v-if="data.order_status === 'Retur'"
                class="mt-1 justify-end"
              >
                <BCol lg="3" />
                <BCol
                  lg="5"
                >
                  Ongkos Kirim Pengembalian (diskon {{ data.percentage_cost_retur }}%)
                </BCol>
                <BCol
                  lg="3"
                  class="text-right #E31A1A"
                >
                  - {{ IDR(data.shipping_retur) }}
                </BCol>
              </BRow>
              <BRow
                v-if="data.is_insurance === 1"
                class="mt-1 justify-end"
              >
                <BCol lg="3" />
                <BCol lg="5">
                  <div class="d-flex">
                    <span class="mr-1">Biaya Asuransi</span>
                    <img
                      id="popover-asuransi"
                      src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                      alt=""
                    >
                    <b-popover
                      triggers="hover focus"
                      target="popover-asuransi"
                      placement="topright"
                    >
                      <a
                        href="https://bantuan.komerce.id/id/article/asuransi-pengiriman-ekspedisi-di-komship-17pow0b/?bust=1678871763794"
                        target="_blank"
                        class="text-[#08A0F7]"
                      ><u>Klik disini</u></a> buat detail tarifnya.
                    </b-popover>
                  </div>
                </BCol>
                <BCol
                  lg="3"
                  class="text-right text-[#F95031]"
                >
                  <span>- {{ IDR(data.insurance_fee) }}</span>
                </BCol>
              </BRow>
            </BCollapse>
            <BRow class="mt-1 justify-end">
              <BCol lg="3" />
              <BCol
                lg="5"
                class="font-bold"
              >
                Penghasilan bersih yang kamu dapatkan
              </BCol>
              <BCol
                v-if="statusNetProfit === '-'"
                lg="3"
                class="text-right text-[#E31A1A] font-bold"
              >
                - {{ IDR(Math.abs(Number(data.net_profit))) }}
              </BCol>
              <BCol
                v-else
                lg="3"
                class="text-right text-success font-bold"
              >
                {{ IDR(Math.abs(Number(data.net_profit))) }}
              </BCol>
            </BRow>
          </BCard>
        </BCol>
      </BRow>
      <ModalPrint :data="data" />
      <ModalTracking
        :awb="data.airway_bill"
        :data="data"
      />
      <b-modal
        id="tracking-resi-collaborator"
        ref="tracking-resi-collaborator"
        hide-footer
        hide-header
        centered
        size="lg"
      >
        <BOverlay
          spinner-variant="primary"
          variant="light"
          blur="0"
          opacity=".5"
          rounded="sm"
        >
          <div>
            <HistoryShipping
              id="tracking-resi-collaborator"
              :awb="data.airway_bill"
              :shipping-image="data.shipping_logo"
              :shipping="data.shipping"
            />
          </div>
        </BOverlay>
      </b-modal>
      <ModalConfirm
        id="confirm-cancel-order"
        ref="confirm-cancel-order"
        title="Cancel Order"
        message="Kamu yakin mau membatalkan orderan resi ini"
        label-confirm-button="Cancel Order"
        label-cancel-button="Kembali"
        :loading-confirm-button="loading"
        @on-click-cancel-button="$bvModal.hide('confirm-cancel-order')"
        @on-click-confirm-button="handleConfirmCancelOrder"
      />
      <ModalConfirm
        id="confirm-update-order"
        ref="confirm-update-order"
        title="Check Update"
        message="konfirmasi dan pemberitahuan waktu tunggu 1-3 menit untuk proses update status tersebut"
        :loading-confirm-button="loading"
        @on-click-cancel-button="$bvModal.hide('confirm-update-order')"
        @on-click-confirm-button="handleUpdateOrder"
      />
      <ModalConfirm
        id="confirm-change-loss-order"
        ref="confirm-change-loss-order"
        title="Mengubah Paket ke Hilang"
        :message="moreThan14Days(data.ticket.last_update)"
        label-confirm-button="Update via Alur Tiket"
        label-cancel-button="Update Status Order"
        :loading-confirm-button="loading"
        @on-click-cancel-button="handleChangeStatusOrder('package_lost', 'confirm-change-loss-order', 'force')"
        @on-click-confirm-button="handleChangeStatusOrder('package_lost', 'confirm-change-loss-order', 'ticket')"
      />
      <ModalConfirm
        id="confirm-change-damaged-order"
        ref="confirm-change-damaged-order"
        title="Mengubah Paket ke Rusak"
        message="Orderan ini akan diubah statusnya menjadi <span class='font-bold'>Paket Rusak</span>. Dampaknya akan membuat / mengupdate tiket dengan resi tersebut ke status “Perlu tindak lanjut seller” untuk proses claim Nett Profit."
        label-confirm-button="Update via Alur Tiket"
        label-cancel-button="Update Status Order"
        :loading-confirm-button="loading"
        @on-click-cancel-button="handleChangeStatusOrder('package_damaged', 'confirm-change-damaged-order', 'force')"
        @on-click-confirm-button="handleChangeStatusOrder('package_damaged', 'confirm-change-damaged-order', 'ticket')"
      />
      <ModalConfirm
        id="confirm-retur"
        ref="confirm-retur"
        title="Konfirmasi Paket Retur"
        :message="`Kamu yakin mau mengubah status orderan ini ke Paket Retur (${isDeductBalance ? 'Memotong Saldo' : 'Tidak Memotong Saldo'})?`"
        label-confirm-button="Ya, Proses"
        label-cancel-button="Batal"
        :loading-confirm-button="loading"
        @on-click-cancel-button="$bvModal.hide('confirm-retur')"
        @on-click-confirm-button="handleConfirmRetur"
      />

      <ModalChangeDelivered
        ref="change-delivered"
        :order-id="data.order_id"
      />

      <!-- Download Invoice PDF Generator -->
      <DownloadInvoice
        ref="downloadInvoice"
        :data="data"
        :show-price="showPriceInvoice"
        @loading="loadingDownload = $event"
      />
    </BCard>
  </div>
</template>

<script>
import { DAY_MONTH_YEAR, FULL_DATE_TIME } from '@/libs/filterDate'
import { IDR } from '@/libs/currency'
import { komshipAxiosIns, collaboratorAxiosIns } from '@/libs/axios'
import ModalConfirm from '@/views/components/modal/ModalConfirm.vue'
import HistoryShipping from '@/views/pages/tiket/detail-ticket-collaborator/history-shipping-collaborator.vue'
import { columns } from './config'
import ModalPrint from './ModalPrint.vue'
import ModalTracking from './ModalTracking.vue'
import BadgeStatusOrder from './BadgeStatusOrder.vue'
import ModalChangeDelivered from './component/ModalChangeDelivered.vue'
import DownloadInvoice from './component/DownloadInvoice.vue'

export default {
  components: {
    ModalPrint, ModalTracking, ModalConfirm, BadgeStatusOrder, ModalChangeDelivered, DownloadInvoice, HistoryShipping,
  },
  data() {
    return {
      DAY_MONTH_YEAR,
      FULL_DATE_TIME,
      IDR,

      loadingPage: false,
      showDataOrder: false,
      showMessage: false,
      messageNotFound: '',
      statusNetProfit: null,
      fields: columns,
      items: [],
      data: {},
      dataTracking: {},
      loading: false,
      invoiceFormat: 'pdf',
      showPriceInvoice: false,
      loadingDownload: false,
      isDeductBalance: false,
    }
  },
  computed: {
    isOrderReturDiterima() {
      return this.data.order_status === 'Retur' && this.data.is_retur === 2
    },
    isOrderReturDalamPerjalanan() {
      return this.data.order_status === 'Retur' && this.data.is_retur === 1
    },
    isDisableCancelOrder() {
      return this.loading || this.isOrderReturDiterima || this.isOrderReturDalamPerjalanan || ['Diterima', 'Batal'].includes(this.data.order_status)
    },
    isDisableButtonPaketHilangAndPaketRusak() {
      return this.loading
    },
    isDisableUpdateOrder() {
      return this.loading || this.isOrderReturDiterima || ['Diterima', 'Batal', 'Diajukan'].includes(this.data.order_status)
    },
    noTicket() {
      return this.data.is_problem === 1 ? this.data.ticket.ticket_no : '-'
    },
    statusOrderVariant() {
      const status = this.data.order_status
      if (status === 'Diajukan') {
        return 'primary'
      } if (status === 'Dipacking') {
        return 'info'
      } if (status === 'Dikirim') {
        return 'warning'
      } if (status === 'Diterima') {
        return 'success'
      } if (status === 'Retur' || status === 'Hilang' || status === 'Rusak') {
        return 'danger'
      } if (status === 'Batal') {
        return 'dark'
      }
      return ''
    },
    invoiceFormatLabel() {
      return this.invoiceFormat === 'pdf' ? 'Invoice PDF' : 'Invoice Image'
    },
  },
  mounted() {
    this.fetchOrderDetail()
  },
  methods: {
    async fetchOrderDetail() {
      this.loadingPage = true
      this.showMessage = false
      const q = this.$route.params.id
      try {
        const res = await komshipAxiosIns.get(`/v1/admin/order/search?q=${q}`)
        const { data } = res.data
        this.data = data
        this.items = data.product || []
        this.statusNetProfit = data.net_profit ? data.net_profit.toString().charAt(0) : ''
        this.showDataOrder = true
      } catch (err) {
        this.showMessage = true
        this.showDataOrder = false
        this.messageNotFound = err?.response?.data?.message || 'Order data tidak ditemukan'
      } finally {
        this.loadingPage = false
      }
    },

    handleDownloadInvoice() {
      if (this.invoiceFormat === 'pdf') {
        this.$refs.downloadInvoice.generate()
      } else {
        this.$refs.downloadInvoice.generateImage()
      }
    },
    async getTicketTrip() {
      const id = this.data.is_komship === 1 ? 'tracking-resi' : 'tracking-resi-collaborator'
      this.$bvModal.show(id)
    },
    async copyResi(resi) {
      await navigator.clipboard.writeText(resi)
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        didOpen: toast => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer)
          toast.addEventListener('mouseleave', this.$swal.resumeTimer)
        },
      })
      Toast.fire({
        icon: 'success',
        title: '<span class="text-success">Success copy to clipboard</span>',
        showCloseButton: true,
      })
      // eslint-disable-next-line no-empty
    },
    printLabel() {
      this.$$bvModal.show('print-label')
    },
    trackingShowCondition(status) {
      if (status === 'Diajukan' || status === 'Dipacking') {
        return false
      }
      return true
    },
    handleConfirmCancelOrder() {
      this.loading = true
      const isKomship = this.data.is_komship === 1
      let env

      if (isKomship) {
        env = komshipAxiosIns.post(`/v1/admin/order/cancel/${this.data.order_id}`)
      } else {
        env = collaboratorAxiosIns.put('/order/api/v1/orders/admin/cancel-order', { order_no: this.data.order_no })
      }

      env.then(async () => {
        await this.fetchOrderDetail()
        this.$toast_success({ message: 'Order berhasil dibatalkan' })
      })
        .catch(error => {
          this.$toast_error({ message: error.response.data.message || 'Gagal cancel order' })
        })
        .finally(() => {
          this.$bvModal.hide('confirm-cancel-order')
          this.loading = false
        })
    },
    handleUpdateOrder() {
      this.loading = true

      const isKomship = this.data.is_komship === 1
      const url = isKomship ? '/v1/admin/order/check-update' : '/order/api/v1/orders/admin/order-check-update'
      const env = isKomship ? komshipAxiosIns : collaboratorAxiosIns
      const action = isKomship ? 'post' : 'get'
      const body = isKomship
        ? { order_no: this.data.order_no }
        : { order_id: this.data.order_id }

      env[action](url, action === 'get' ? { params: body } : body)
        .then(async () => {
          await this.fetchOrderDetail()
          this.$toast_success({ message: 'Check update berhasil' })
        })
        .catch(error => {
          this.$toast_error({ message: error.response.data.message || 'Gagal update order' })
        })
        .finally(() => {
          this.$bvModal.hide('confirm-update-order')
          this.loading = false
        })
    },
    navigateToTicketDetail() {
      const id = this.data.is_komship === 1 ? this.data.ticket.id : this.data.ticket.ticket_no
      const url = this.$router.resolve({
        path: `${this.data.is_komship === 1 ? '/tiket' : '/tiket/kolaborator'}/detail/${id}`,
        params: { data_tiket: this.data.ticket.ticket_no },
      })
      window.open(url.href, '_blank')
    },
    handlePaketHilang() {
      if (['Diajukan', 'Batal', 'Dipacking', 'Diterima'].includes(this.data.order_status) || this.isOrderReturDiterima) {
        this.$toast_error({ message: 'Tidak bisa Update Order dari orderan yang statusnya  "Dibuat", "Dibatalkan", "Dipacking", "Diterima", dan "Retur diterima"' })
      } else if (this.data.order_status === 'Dikirim' || this.isOrderReturDalamPerjalanan) {
        this.$bvModal.show('confirm-change-loss-order')
      }
    },
    handlePaketRusak() {
      if (['Diajukan', 'Batal', 'Dipacking', 'Diterima'].includes(this.data.order_status)) {
        this.$toast_error({ message: 'Tidak bisa Update Order dari orderan yang statusnya  "Dibuat", "Dibatalkan"/"Dipacking", "Diterima"' })
      } else if (this.data.order_status === 'Dikirim' || this.isOrderReturDalamPerjalanan || this.isOrderReturDiterima) {
        this.$bvModal.show('confirm-change-damaged-order')
      }
    },
    handleCancelOrder() {
      if (['Diterima', 'Batal'].includes(this.data.order_status) || this.isOrderReturDiterima || this.isOrderReturDalamPerjalanan) {
        this.$toast_error({ message: 'Tidak bisa Cancel Order dari orderan yang statusnya "Diterima", "Dibatalkan", dan "Retur"' })
      } else {
        this.$bvModal.show('confirm-cancel-order')
      }
    },
    handleChangeStatusOrder(nextStatus, modalId, forceStatus) {
      this.loading = true

      const url = '/v1/admin/order/manual-transaction'

      const body = {
        order_id: this.data.order_id,
        order_status: nextStatus,
        is_hard_complaint: forceStatus === 'force' ? 1 : 0,
      }

      komshipAxiosIns.post(url, body)
        .then(() => {
          this.$toast_success({ message: 'Berhasil update status order' })
          this.fetchOrderDetail()
        })
        .catch(error => {
          this.$toast_error({ message: error.response.data.message || 'Gagal update status order' })
        })
        .finally(() => {
          this.$bvModal.hide(modalId)
          this.loading = false
        })
    },
    handleDeliveredPackage() {
      this.$refs['change-delivered'].show()
    },
    handleReturMemotong() {
      this.isDeductBalance = true
      this.$bvModal.show('confirm-retur')
    },
    handleReturTidakMemotong() {
      this.isDeductBalance = false
      this.$bvModal.show('confirm-retur')
    },
    handleConfirmRetur() {
      this.loading = true
      const body = {
        order_no: this.data.order_no,
        is_deduct_balance: this.isDeductBalance,
        is_komship: this.data.is_komship === 1,
      }

      komshipAxiosIns.put('/v1/admin/order/retur', body)
        .then(() => {
          this.$toast_success({ message: 'Berhasil memproses paket retur' })
          this.fetchOrderDetail()
        })
        .catch(error => {
          this.$toast_error({ message: error.response?.data?.message || 'Gagal memproses paket retur' })
        })
        .finally(() => {
          this.$bvModal.hide('confirm-retur')
          this.loading = false
        })
    },
    moreThan14Days(lastDate) {
      const date = new Date(lastDate)
      const now = new Date()
      const diffTime = Math.abs(now - date)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

      if (lastDate !== null && diffDays > 14) {
        return `
          <div class="mb-[24px]">Orderan ini akan diubah statusnya menjadi “Paket Hilang”, menyelesaikan tiket dan menambah saldo user secara langsung</div>
          <div class="flex items-center gap-[12px] bg-[#FCEBBE] font-semibold px-[20px] py-[16px] text-start rounded-[4px]">
            <img src="https://storage.googleapis.com/komerce/assets/svg/warning-Info-circle.svg" width="24" />
            Paket Sudah Stuck Lebih dari 14 Hari
          </div>
        `
      }
      return `
        Orderan ini akan diubah statusnya menjadi <span class="font-bold">Paket Hilang</span>.
        Dampaknya akan membuat / mengupdate tiket dengan resi tersebut ke status “Perlu tindak lanjut seller” untuk proses claim Nett Profit.
        <div class="items-center bg-[#FFF2E2] px-[20px] py-[16px] text-start rounded-[4px] mt-[24px]">
            <div class="flex gap-[12px] font-semibold ">
              <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/danger.svg" width="24" />
              Update Status Order
            </div>
            <span class="text-xs text-[#626262]">
              Update akan menyelesaikan tiket secara paksa ke Selesai
            </span>
        </div>
      `
    },
  },
}
</script>

<style scoped lang="scss">
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #C2C2C2;
  border-color: #C2C2C2 !important
}

.btn-primary.disabled, .btn-primary:disabled {
  background-color: #C2C2C2 !important;
  border-color: #C2C2C2 !important
}

.order-dropdown ::v-deep .dropdown-toggle {
  padding: 0.486rem !important;
}

.order-dropdown-item ::v-deep .dropdown-item {
  width: 100%;
  padding: 10px;
}

.order-dropdown-item ::v-deep button:focus {
  outline: none !important;
}

.order-dropdown ::v-deep .dropdown-menu {
  min-width: 200px;
}

/* Dropdown Submenu */
.dropdown-submenu {
  position: relative;
  list-style: none;

  .submenu-list {
    display: none;
    position: absolute;
    top: 0;
    right: 100%;
    margin-right: 0px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
    padding: 8px;
    list-style: none;
    min-width: 180px;
    z-index: 1050;

    ::v-deep .order-dropdown-item {
      list-style: none;

      .dropdown-item {
        padding: 10px 16px;
        border-radius: 6px;
        color: #2c3e50;
        font-size: 14px;
        font-weight: 500;
        text-align: left;
        transition: all 0.2s ease;
        background-color: transparent;

        &:hover {
          background-color: #F95031 !important; /* Orange primary color */
          color: #fff !important;
        }
      }
    }
  }

  &:hover {
    > ::v-deep .order-dropdown-item .dropdown-item {
      background-color: #FFEFEB !important;
      color: #F95031 !important;
    }

    .submenu-list {
      display: block;
    }
  }
}
</style>
